import { type AgGridReact } from "@jsq/ds/core";

export const INDIVIDUALS_TABLE_PAGE_SIZE = 50;

// TODO: Replace with a backend-provided unique ID when available
export const getIndividualRowId = (params: {
  data?: { assigneeName: string; assigneeEmail: string | null };
}): string => {
  if (!params.data) return "";
  return `${params.data.assigneeName}_${params.data.assigneeEmail ?? ""}`;
};

export const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  suppressCellFocus: true,
  suppressRowHoverHighlight: false,
  domLayout: "normal",
  rowHeight: 62,
  onSortChanged: (event) => {
    event.api.paginationGoToFirstPage();
    event.api.refreshServerSide({ purge: true });
  },
  defaultColDef: {
    resizable: true,
    menuTabs: [],
    sortable: true,
    suppressHeaderMenuButton: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: 100,
  },
  suppressRowClickSelection: true,
  pagination: true,
  paginationPageSize: INDIVIDUALS_TABLE_PAGE_SIZE,
  paginationPageSizeSelector: [25, 50, 100],
  rowModelType: "serverSide",
  cacheBlockSize: INDIVIDUALS_TABLE_PAGE_SIZE,
  maxBlocksInCache: 10,
  getRowId: getIndividualRowId,
  suppressHorizontalScroll: false,
  enableBrowserTooltips: true,
  suppressContextMenu: true,
  autoSizeStrategy: {
    type: "fitGridWidth",
  },
  statusBar: {
    statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
  },
};
